<div class="td-wb-fpl-introduction">
  <h2 class="td-wb-fpl-introduction__header"
      translate="tdWb.fpl.introduction.HEADER"></h2>
  <div class="td-wb-fpl-introduction__subheader"
       translate="tdWb.fpl.introduction.SUBHEADER"></div>
  <div class="td-wb-fpl-introduction__intro-container"
       role="region">
    <div class="td-wb-fpl-introduction__intro-container-inner">
      <a class="td-wb-fpl-introduction__intro-container-link td-wb-link"
         tdWbHref="link_stock_lending_video"
         tdWbHrefTaggingEvent="stocklending:video:click"
         target="_blank"
         rel="noopener">
        <div class="td-wb-fpl-introduction__intro-play-container">
          <img class="td-wb-fpl-introduction__image"
               [src]="'tdWb.fpl.introduction.IMAGE_URL' | tdWbTranslate"
               [attr.alt]="'tdWb.fpl.introduction.WATCH_VIDEO_LINK' | tdWbTranslate">
          <div class="td-wb-fpl-introduction__intro-play">
            <td-wb-icon iconId="play-video"
                        size="70x70"></td-wb-icon>
          </div>
        </div>
      </a>
    </div>
    <div class="td-wb-fpl-introduction__intro-container-inner td-wb-fpl-introduction__intro-container-inner--right">
      <img class="td-wb-fpl-introduction__intro-icon"
           alt=""
           src="assets/images/sfy/sfy-fpl.svg"
           width="50"
           height="50"/>
      <h2 class="td-wb-fpl-introduction__intro-header"
          translate="tdWb.fpl.introduction.INTRO_HEADER"></h2>
      <p class="td-wb-fpl-introduction__intro-body"
         translate="tdWb.fpl.introduction.INTRO_DESCRIPTION"></p>
        @if (enrollmentStatus() === 'ELIGIBLE') {
          <div class="td-wb-fpl-introduction__intro-button">
            <button id="td-wb-fpl-introduction-enrol-now"
                    tdWbButton
                    tdWbHref="modal.fpl-enrollment"
                    tdWbButtonType="primary"
                    tdWbHrefTaggingEvent="stocklending:enroll">
              <span translate="tdWb.fpl.introduction.INTRO_BUTTON"></span>
            </button>
          </div>
        } @else if (accountGroups().length === 0) {
          <div class="td-wb-fpl-introduction__intro-body td-wb-fpl-introduction__intro-body--bold">
            @if (modalView()) {
              <span translate="tdWb.fpl.introduction.INTRO_DESCRIPTION_INELIGIBLE_MODAL"></span>
            } @else {
              <span translate="tdWb.fpl.introduction.INTRO_DESCRIPTION_INELIGIBLE"></span>
            }
          </div>
          <div class="td-wb-fpl-introduction__intro-button">
            <button id="td-wb-fpl-introduction-open-new-account"
                    tdWbButton
                    tdWbHref="link_open_new_account"
                    tdWbButtonType="marketing"
                    [tdWbHrefOptions]="{ location: 'replace' }"
                    tdWbHrefTaggingEvent="stocklending:open cash account">
              <td-wb-icon iconId="lock"
                          size="18">
              </td-wb-icon>
              <span translate="tdWb.fpl.introduction.INTRO_BUTTON_LABEL"></span>
            </button>
          </div>
        } @else {
          <div class="td-wb-fpl-introduction__intro-body td-wb-fpl-introduction__intro-body--bold">
            <span translate="tdWb.fpl.introduction.ELIGIBLE_ACCOUNTS_1"></span>
            <a class="td-wb-fpl-introduction__eligible-accounts-link"
               role="button"
               tabindex="0"
               [tdWbOverlayToggle]="accountsDisplayTemplate"
               tdWbOverlaySize="x-small"
               tdWbOverlayPosition="end-bottom">
               <span>[{{ totalAccounts }}]</span>
               <span translate="tdWb.fpl.introduction.ELIGIBLE_ACCOUNTS_2"></span>
            </a>
            <span>.</span>
          </div>
        }
    </div>
  </div>
  <div>
    <h2 class="td-wb-fpl-introduction__header-enrol"
        translate="tdWb.fpl.introduction.whyEnrolSection.TITLE"></h2>
    <div class="td-wb-fpl-introduction__enrol-container">
      <div class="td-wb-fpl-introduction__enrol-container-inner">
        <div class="td-wb-fpl-introduction__enrol-container-inner__section">
          <td-wb-icon class="td-wb-fpl-introduction__enrol-icon"
                      iconId="generate-income"
                      size="48">
          </td-wb-icon>
          <div>
            <h3 class="td-wb-fpl-introduction__enrol-header"
                translate="tdWb.fpl.introduction.whyEnrolSection.HEADER_1"></h3>
            <p class="td-wb-fpl-introduction__enrol-body"
               translate="tdWb.fpl.introduction.whyEnrolSection.BODY_1"></p>
          </div>
        </div>
        <div class="td-wb-fpl-introduction__enrol-container-inner__section">
          <td-wb-icon class="td-wb-fpl-introduction__enrol-icon"
                      iconId="td-direct-investing"
                      size="48">
          </td-wb-icon>
          <div>
            <h3 class="td-wb-fpl-introduction__enrol-header"
                translate="tdWb.fpl.introduction.whyEnrolSection.HEADER_2"></h3>
            <p class="td-wb-fpl-introduction__enrol-body"
               translate="tdWb.fpl.introduction.whyEnrolSection.BODY_2"></p>
          </div>
        </div>
      </div>

      <div class="td-wb-fpl-introduction__enrol-container-inner">
        <div class="td-wb-fpl-introduction__enrol-container-inner__section">
          <td-wb-icon class="td-wb-fpl-introduction__enrol-icon"
                      iconId="no-fee"
                      size="48"></td-wb-icon>
          <div>
            <h3 class="td-wb-fpl-introduction__enrol-header"
                translate="tdWb.fpl.introduction.whyEnrolSection.HEADER_3"></h3>
            <p class="td-wb-fpl-introduction__enrol-body"
               translate="tdWb.fpl.introduction.whyEnrolSection.BODY_3"></p>
          </div>
        </div>

        <div>
          <div class="td-wb-fpl-introduction__enrol-container-inner__section">
            <td-wb-icon class="td-wb-fpl-introduction__enrol-icon"
                        iconId="fraud"
                        size="48"></td-wb-icon>
            <div>
              <h3 class="td-wb-fpl-introduction__enrol-header"
                  translate="tdWb.fpl.introduction.whyEnrolSection.HEADER_4"></h3>
              <p class="td-wb-fpl-introduction__enrol-body"
                 translate="tdWb.fpl.introduction.whyEnrolSection.BODY_4"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #accountsDisplayTemplate>
  <td-wb-overlay aria-labelledby="overlay-title">
    <td-wb-overlay-header id="td-wb-introduction-overlay-title">
      <span translate="tdWb.fpl.introduction.toolTipSection.TITLE"></span>
    </td-wb-overlay-header>
    @for (group of accountGroups(); track group) {
      <div class="td-wb-fpl-introduction-eligible-accounts__overlay">
        @for (account of group.accounts; track account) {
          <span class="td-wb-fpl-introduction-eligible-account" >
            <td-wb-icon-flag class="td-wb-fpl-introduction-eligible-account__flag" [value]="account.currency"></td-wb-icon-flag>
            <span class="td-wb-fpl-introduction-eligible-account__number" [innerText]="account.number"></span>
            <span class="td-wb-fpl-introduction-eligible-account__dash">&ndash;</span>
            <span class="td-wb-fpl-introduction-eligible-account__desc">
              <span [innerText]="account.description"></span>
            </span>
          </span>
        }
      </div>
    }
  </td-wb-overlay>
</ng-template>
